// NOTE: `competency` is a self-assessment on a 1-5 scale. It sets the bar
// widths on the resume page. These values come from the CV's emphasis, not
// from any measurement. Review them and adjust.

const skills = [
  // ---- Languages ----
  {
    title: 'Python',
    competency: 5,
    category: ['Languages'],
  },
  {
    title: 'SQL',
    competency: 4,
    category: ['Languages', 'Databases'],
  },
  {
    title: 'Java',
    competency: 4,
    category: ['Languages'],
  },
  {
    title: 'Scala',
    competency: 3,
    category: ['Languages', 'Data Engineering'],
  },
  {
    title: 'R',
    competency: 4,
    category: ['Languages', 'Data Science'],
  },
  {
    title: 'Bash',
    competency: 3,
    category: ['Languages', 'Data Engineering'],
  },

  // ---- ML & NLP ----
  {
    title: 'PyTorch',
    competency: 4,
    category: ['ML & NLP'],
  },
  {
    title: 'HuggingFace Transformers',
    competency: 4,
    category: ['ML & NLP'],
  },
  {
    title: 'Embedding retrieval',
    competency: 4,
    category: ['ML & NLP'],
  },
  {
    title: 'Topic modeling',
    competency: 4,
    category: ['ML & NLP', 'Data Science'],
  },
  {
    title: 'Information extraction',
    competency: 4,
    category: ['ML & NLP', 'Data Science'],
  },
  {
    title: 'Model evaluation',
    competency: 4,
    category: ['ML & NLP', 'Data Science'],
  },
  {
    title: 'TensorFlow',
    competency: 3,
    category: ['ML & NLP'],
  },
  {
    title: 'Scikit-Learn',
    competency: 4,
    category: ['ML & NLP', 'Data Science'],
  },

  // ---- Data Engineering / Orchestration ----
  {
    title: 'Dagster',
    competency: 5,
    category: ['Data Engineering'],
  },
  {
    title: 'Spark',
    competency: 4,
    category: ['Data Engineering'],
  },
  {
    title: 'Slurm / HPC',
    competency: 4,
    category: ['Data Engineering'],
  },
  {
    title: 'Ray',
    competency: 3,
    category: ['Data Engineering'],
  },
  {
    title: 'Pandas',
    competency: 5,
    category: ['Data Engineering', 'Data Science'],
  },
  {
    title: 'NumPy',
    competency: 4,
    category: ['Data Engineering', 'Data Science'],
  },
  {
    title: 'Matplotlib',
    competency: 4,
    category: ['Data Science'],
  },

  // ---- Cloud & Infrastructure ----
  {
    title: 'Docker',
    competency: 4,
    category: ['Cloud & Infrastructure'],
  },
  {
    title: 'Kubernetes',
    competency: 4,
    category: ['Cloud & Infrastructure'],
  },
  {
    title: 'CI/CD',
    competency: 4,
    category: ['Cloud & Infrastructure'],
  },
  {
    title: 'AWS (EMR, S3)',
    competency: 4,
    category: ['Cloud & Infrastructure'],
  },
  {
    title: 'GCP (GCS, GKE, Vertex AI)',
    competency: 3,
    category: ['Cloud & Infrastructure'],
  },

  // ---- Databases ----
  {
    title: 'DuckDB',
    competency: 4,
    category: ['Databases'],
  },
  {
    title: 'PostgreSQL / MySQL',
    competency: 4,
    category: ['Databases'],
  },
  {
    title: 'MongoDB',
    competency: 3,
    category: ['Databases'],
  },
  {
    title: 'Object storage (S3/GCS)',
    competency: 4,
    category: ['Databases', 'Cloud & Infrastructure'],
  },
].map((skill) => ({ ...skill, category: skill.category.sort() }));

// this is a list of colors that I like. The length should be == to the
// number of categories. Re-arrange this list until you find a pattern you like.
const colors = [
  '#6968b3',
  '#37b1f5',
  '#40494e',
  '#515dd4',
  '#e47272',
  '#cc7b94',
  '#3896e2',
  '#c3423f',
  '#d75858',
  '#747fff',
  '#64cb7b',
];

const categories = [...new Set(
  skills.reduce((acc, { category }) => acc.concat(category), []),
)].sort().map((category, index) => ({
  name: category,
  color: colors[index],
}));

export { categories, skills };
